"use client";
import React from "react";
import s from "./style.module.scss";
import TestimonialCard from "./TestimonialCard";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

type MasonryGalleryProps = {
  testimonials: Array<{
    image: string;
    name: string;
    country: string;
    tr_description: string;
    stars_rating: string;
  }>;
  verifiedBuyerLabel: string;
};

const MasonryGallery = ({
  testimonials,
  verifiedBuyerLabel,
}: MasonryGalleryProps) => (
  <ResponsiveMasonry columnsCountBreakPoints={{ 0: 1, 768: 3 }}>
    <Masonry className={s.testimonials__masonry}>
      {testimonials.map((card, index) => (
        <TestimonialCard
          key={index}
          card={card}
          verifiedBuyerLabel={verifiedBuyerLabel}
        />
      ))}
    </Masonry>
  </ResponsiveMasonry>
);

export default MasonryGallery;
